import { writable } from "svelte/store";
export const roleStore = writable(null);
